import React, { useState } from "react";

/**
 * Безопасная картинка с заглушкой:
 * - если src пустой или загрузка/декодирование упали — покажем fallback;
 * - не дёргаем layout: класс и размеры приходят снаружи.
 */
export default function SafeImage({ src, fallback = "/no-image.svg", alt = "", className = "" }) {
  const [broken, setBroken] = useState(!src);
  const real = broken ? fallback : src;

  return (
    <img
      src={real}
      alt={alt || ""}
      className={className}
      loading="lazy"
      decoding="async"
      onError={() => setBroken(true)}
    />
  );
}
